var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 94.7916C25.2918 94.7916 5.2085 74.7083 5.2085 49.9999C5.2085 25.2916 25.2918 5.20825 50.0002 5.20825C74.7085 5.20825 94.7918 25.2916 94.7918 49.9999C94.7918 74.7083 74.7085 94.7916 50.0002 94.7916ZM50.0002 11.4583C28.7502 11.4583 11.4585 28.7499 11.4585 49.9999C11.4585 71.2499 28.7502 88.5416 50.0002 88.5416C71.2502 88.5416 88.5418 71.2499 88.5418 49.9999C88.5418 28.7499 71.2502 11.4583 50.0002 11.4583Z",
    fill: "#EA5455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2083 64.9167C37.4167 64.9167 36.625 64.625 36 64C34.7917 62.7917 34.7917 60.7917 36 59.5833L59.5833 36C60.7917 34.7917 62.7917 34.7917 64 36C65.2083 37.2083 65.2083 39.2083 64 40.4167L40.4167 64C39.8333 64.625 39 64.9167 38.2083 64.9167Z",
    fill: "#EA5455"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7917 64.9167C61 64.9167 60.2083 64.625 59.5833 64L36 40.4167C34.7917 39.2083 34.7917 37.2083 36 36C37.2083 34.7917 39.2083 34.7917 40.4167 36L64 59.5833C65.2083 60.7917 65.2083 62.7917 64 64C63.375 64.625 62.5833 64.9167 61.7917 64.9167Z",
    fill: "#EA5455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle1);
export default __webpack_public_path__ + "static/media/close-circle1.aa1d8c7d67d017b44c1550a849d76e8d.svg";
export { ForwardRef as ReactComponent };